import React, { FC } from 'react'

import LikesIcon from 'src/Assets/Svg/campaignDetails/spotify_stats.svg?react'
import { StatsBlock } from 'src/Components/StatsSectionBlock'
import { CampaignStatusEnum } from 'src/Types/campaigns'

interface StatsBlockContainerProps {
  reviewsCount?: number
  placementsCount?: number
  campaignStatus?: CampaignStatusEnum
}

export const StatsBlockContainer: FC<StatsBlockContainerProps> = ({
  reviewsCount,
  placementsCount,
  campaignStatus,
}) => {
  if (!campaignStatus) {
    return null
  }

  const sections = [
    {
      title: 'Feedback',
      value: reviewsCount,
    },
    {
      title: 'Placements',
      value: placementsCount,
    },
  ]

  const isStatsBlockHidden =
    [
      CampaignStatusEnum.PENDING_APPROVAL,
      CampaignStatusEnum.APPROVED,
      CampaignStatusEnum.SCHEDULED,
    ].includes(campaignStatus) ||
    (campaignStatus === CampaignStatusEnum.RUNNING && reviewsCount === 0)

  if (isStatsBlockHidden) {
    return null
  }

  return (
    <StatsBlock
      sections={sections}
      icon={<LikesIcon data-testid='likes-icon' />}
    />
  )
}
